module.exports = __webpack_public_path__ + "img/icon-redy.c608ff59.svg";